import React, { useState } from 'react';
import { useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FiltersSection } from './FiltersSection';
import {
  chipsStyles,
  FiltersOptionsWrapper,
  RangeFilterWrapper
} from './styled';
import { RangeFilter } from '../../../ui/RangeFilter';
import { RangeFilterWithOptionsContainer } from '../styled';
import { Chips } from '../../../ui/Chips';

const lastFloor = [
  {
    value: 'false',
    id: 'new-search-not-last',
    name: 'new_search.not_last'
  },
  {
    value: 'true',
    id: 'new-search-only-last',
    name: 'new_search.last_floor'
  }
];

export const NewSearchFloors = () => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change, getFieldState } = useForm();
  const [prevValue, setPrevValue] = useState<string | null>(null);
  const valueFirst = values.floor_first;
  const valueLast = values.floor_last;
  const fromFloorValue = values.floor_from;
  const toFloorValue = values.floor_to;

  const handleFirstFloorChange = (value: boolean) => {
    const { value: fieldValue } = getFieldState('floor_from');

    if (value && +fieldValue === 1) {
      change('floor_from', undefined);
      change('floor_first', value);
    } else if (!value) {
      change('floor_first', undefined);
    } else {
      change('floor_first', value);
    }
  };

  const handleLastFloorChange = (value: string) => {
    if (prevValue === value) {
      setPrevValue(null);
      change('floor_last', undefined);
    } else {
      setPrevValue(value);
      change('floor_last', value);
    }

    if (value === 'false' && fromFloorValue === toFloorValue) {
      change('floor_from', undefined);
    }
  };

  return (
    <FiltersSection title={t('search.form.floor')}>
      <RangeFilterWithOptionsContainer>
        <RangeFilterWrapper>
          <RangeFilter
            minName="floor_from"
            minId="new-search-form-floor-from"
            maxId="new-search-form-floor-to"
            maxName="floor_to"
            rangeInFilterModal
          />
        </RangeFilterWrapper>
        <FiltersOptionsWrapper>
          <Chips
            text={t('new_search.not_first')}
            value={true}
            type="button"
            hasCustomOnChange
            storedValue={valueFirst}
            onClick={() => handleFirstFloorChange(!valueFirst)}
            styles={chipsStyles}
            stat="new-search-form-not-first-floor"
          />
          {lastFloor.map(floor => (
            <Chips
              key={floor.id}
              text={t(floor.name)}
              value={floor.value}
              type="button"
              hasCustomOnChange
              storedValue={valueLast}
              onClick={() => handleLastFloorChange(floor.value)}
              styles={chipsStyles}
              stat="new-search-form-last-floor"
              cypress={floor.id}
            />
          ))}
        </FiltersOptionsWrapper>
      </RangeFilterWithOptionsContainer>
    </FiltersSection>
  );
};
